import {connect} from 'react-redux';
import React from 'react';
import UserModel from '/app/src/model/User/model';
import SystemModel from '/app/src/model/System/model';
import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import EntrySelector from '/app/src/model/Entry/selector';
import ConversationPreview from './Conversation'
import {Flex, SVGButton} from '/app/src/component'

class AssignedContainer extends React.Component {

    __resolveButtonClick(room){
        return () => {
            this.props.dispatch(UserModel.resolveTicket(room));
        }
    }
    __transferButtonClick(room){
        return () => {
            this.props.dispatch(SystemModel.openModal('transfer', {'room': room}));
        }
    }

    render() {
        const {room, customerIsOnline, imageUrl, conversation,
        isTyping, entry, currentRoom, exchange} = this.props

        let unread = ConversationSelector.getUnread(conversation, 0);
        let entryBody =  EntrySelector.body(entry)
        let entryDateCreated = EntrySelector.detailsDateCreated(entry)
        let send = EntrySelector.creatorId(entry) === this.props.userId
        let transferButtonIsActive = this.props.modalRoute === 'transfer'
        return (
            <ConversationPreview
                room={room}
                unread={unread}
                currentRoom={currentRoom}
                title={this.props.customerName}
                imageUrl={imageUrl}
                entryBody={entryBody}
                entryDateCreated={entryDateCreated}
                send={send}
                isOnline={customerIsOnline}
                isTyping={isTyping}
                exchange={exchange}
            >
                <SVGButton
                    text='Överför'
                    src='/images/ErrandTransfer_M.svg'
                    color='lightgrey' border
                    hover='blue'
                    onClick={this.__transferButtonClick(room)}
                    active={transferButtonIsActive}
                />
                <Flex width='30px' shrink={3}></Flex>
                <SVGButton
                    text='Avklara'
                    color='lightgrey' border
                    src='/images/Complete_M.svg'
                    hover='blue'
                    onClick={this.__resolveButtonClick(room)}
                />
            </ConversationPreview>
        );

    }

}

function mapStateToProps(state, ownProps){
    let conversation = ConversationSelector.getByRoom(state, ownProps.room)

    let customerId = ConversationSelector.getCustomerId(conversation)
    let customer = CustomerSelector.getById(state, customerId)
    let customerName = CustomerSelector.getName(customer)
    let customerIsOnline;

    const isTyping = ConversationSelector.getIsTyping(state, ownProps.room);

    if(customer){
        customerIsOnline = customer.getIn(['info', 'payload', 'is_online']);
    }
    let userId = state.getIn(['user', 'login', 'id'])
    let modalRoute = state.getIn(['system', 'modal', 'route'])


    return {
        userId,
        conversation,
        customer,
        customerId,
        customerName,
        customerIsOnline,
        modalRoute,
        isTyping,
        entry: ConversationSelector.lastEntry(conversation),
        exchange: ConversationSelector.getExchange(conversation),
    }


}

export default connect(mapStateToProps)(AssignedContainer);



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/AssignedContainer.js